export enum AimStatusCodeTypes {
  ERROR = 'Error',
  OK = 'Ok',
}

export type AimErrorCodes = '1' | '51' | '223' | 'ELoginFailed' | 'E.00.02' | '59' | '57';

export interface AimStatusResponse {
  StatusCode?: AimStatusCodeTypes;
  ErrorCode?: AimErrorCodes;
  ErrorMessage?: string;
  DomainName?: string;
  IpAddress?: string;
}

export interface AimBaseResponse {
  Status?: AimStatusResponse;
}
